import { DetailsList, PrimaryButton, SelectionMode, Spinner } from "@fluentui/react";
import axios from 'axios';
import { saveAs } from 'file-saver';
import numeral from 'numeral'; // Import numeral library
import { useCallback, useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import * as XLSX from 'xlsx';
import config from '../Admin/config';



const FormularioConsolidadoHistorico = ({companyId}) => {
    const [documentos, setDocumentos] = useState([]);
    const [disabledExcel, setDisabledExcel] = useState(true)
    const [isLoading, setIsLoading] = useState(true); // Track loading state

    const {t} = useTranslation();

    const { id } = useParams();
    numeral.locale('en'); // Change 'en' to the desired locale

    const exportToExcel = (data, columns) => {
      const worksheetData = data.map((item) => {
        const rowData = {
          id: id 
        };
        columns.forEach((column) => {
          rowData[column.fieldName] = item[column.key];
        });
        return rowData;
      });
    
      const worksheet = XLSX.utils.json_to_sheet(worksheetData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
      const excelBuffer = XLSX.write(workbook, {
        bookType: 'xlsx',
        type: 'array',
      });
      const excelBlob = new Blob([excelBuffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      saveAs(excelBlob, id + '.xlsx');
    };
      

    const fetchDocumentoData = useCallback(async () => {
      try {
        const response = await axios.get(`${config.apiUrl}api/items/${id}`, {
          params: {
            company: companyId,
          },
        });
        const data = response.data;
        setDocumentos(data);
        if (data.length > 0) {
          setDisabledExcel(false);
        }
        setIsLoading(false); // Turn off loading state on successful fetch
      } catch (error) {
        alert("Error fetching data:")
        setIsLoading(false);
      }
    }, [companyId, id]);

    useEffect(() => {
        fetchDocumentoData();
    }, [companyId, fetchDocumentoData]);

    const fetchItemsData = useCallback(async () => {
      try {
        const response = await axios.get(`${config.apiUrl}api/items/${id}`, {
          params: {
            company: companyId,
          },
        });
        const data = response.data;
        setDocumentos(data);
        if (data.length > 0) {
          setDisabledExcel(false);
        }
        setIsLoading(false); // Turn off loading state on successful fetch
      } catch (error) {
        alert("Error fetching data:")
        setIsLoading(false);
      }
    }, [companyId, id]);

    useEffect(() => {
      fetchItemsData();
    }, [companyId, fetchItemsData]);
    //grid
    const columns = [
      { key: 'vendorAccount', name: t('Consolidate.Provider'), fieldName: 'vendorAccount', minWidth: 100, maxWidth: 200 },
      { key: 'purchOrderId', name: t('Consolidate.POrder'), fieldName: 'purchOrderId', minWidth: 100, maxWidth: 200 },
      { key: 'purchorderLine', name: t('Consolidate.Line'), fieldName: 'purchorderLine', minWidth: 100, maxWidth: 200 },
      { key: 'itemId', name: t('Consolidate.ItemId'), fieldName: 'itemId', minWidth: 100, maxWidth: 200 },
      { key: 'itemName', name: t('Consolidate.ItemName'), fieldName: 'itemName', minWidth: 100, maxWidth: 200 },
      { key: 'quantity', name: t('Consolidate.Quantity'), fieldName: 'quantity', minWidth: 100, maxWidth: 200 },
      { key: 'costType', name: t('Consolidate.MarkUp'), fieldName: 'costType', minWidth: 100, maxWidth: 200 },
      { key: 'description', name: t('Consolidate.Description'), fieldName: 'description', minWidth: 100, maxWidth: 200 },
      { key: 'landedCostDocument', name: t('Consolidate.LandedCost'), fieldName: 'landedCostDocument', minWidth: 100, maxWidth: 200 },
      { key: 'currency', name: t('Consolidate.Currency'), fieldName: 'currency', minWidth: 100, maxWidth: 200 },
      { key: 'exchangeRate', name: t('Consolidate.Exchange'), fieldName: 'exchangeRate', minWidth: 100, maxWidth: 200 },
      { key: 'transportDocumentDate', name: t('Consolidate.BillDate'), fieldName: 'transportDocumentDate', minWidth: 100, maxWidth: 200 },
      { key: 'chargePercent', name: t('Consolidate.Percent'), fieldName: 'chargePercent', minWidth: 100, maxWidth: 200 ,onRender: (item) => (item.chargePercent).toFixed(2) + '%'},
      { key: 'chargeAmount', name: t('Consolidate.Amount'), fieldName: 'chargeAmount', minWidth: 100, maxWidth: 200 , onRender: (item) => numeral(item.chargeAmount).format('$0,0.00')},
      { key: 'nitTerceroColombia', name: 'Nit', fieldName: 'nitTerceroColombia', minWidth: 100, maxWidth: 200 },
      { key: 'invoice', name: t('Consolidate.Invoice'), fieldName: 'invoice', minWidth: 100, maxWidth: 200 },
      { key: 'documentdate', name: t('Consolidate.InvoiceDate'), fieldName: 'documentdate', minWidth: 100, maxWidth: 200 },
      { key: 'equipmentId', name: t('Consolidate.Equip'), fieldName: 'equipmentId', minWidth:100, maxWidth :200}
    ]
      return (
        <div  className="card">
            <h1>{t('View.Header') + " " + id} </h1>
              {isLoading && // Show loader when loading
              <Spinner label={t("Loading")} />}
              <DetailsList
                  items={documentos}
                  selectionMode={SelectionMode.none}
                  columns={columns}
              />
              <PrimaryButton onClick={() => exportToExcel(documentos, columns)} disabled={disabledExcel}>{t('Consolidate.Excel')}</PrimaryButton>
        </div>
    );
};

const mapStateToProps = (state) => ({
    companyId: state.companyId,
});

export default connect(mapStateToProps)(FormularioConsolidadoHistorico);
